import { ISmevMonitoringChart } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringChart';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { smevMonitoringChartsTypeWithName } from '../constants/smevMonitoringChartsTypeWithName';
import { SmevMonitoringChartTypesEnum } from '../enums/SmevMonitoringChartTypesEnum';
import { ISmevMonitoringChartData } from '../interfaces/ISmevMonitoringChartData';

export const convertChartsInfoToData = (
  charts: ISmevMonitoringChart[],
  isLoading: boolean,
  systemType?: string,
  serviceType?: string,
  endpoint?: string,
  isAdditional?: boolean,
): ISmevMonitoringChartData[] => {
  return charts?.length
    ? charts.map(item => ({
        description: item.description,
        systemType,
        serviceType: serviceType || '',
        endpoint,
        isAdditional,
        isLoading,
        list: Object.entries(deleteObjectProperties(item, ['description']))
          .filter(chartItem => typeof chartItem[1] === 'number' && chartItem[1] > 0)
          .map(chartItem => ({
            name: smevMonitoringChartsTypeWithName[chartItem[0] as SmevMonitoringChartTypesEnum],
            type: chartItem[0] as SmevMonitoringChartTypesEnum,
            value: chartItem[1],
          })),
        isActive: !!(item.failedBySmevMessages || item.failedMessages || item.successfulMessages),
      }))
    : [
        {
          description: '',
          systemType,
          serviceType: serviceType || '',
          endpoint,
          isAdditional,
          isLoading,
          list: [],
          isActive: false,
        },
      ];
};
